<template>
    <div>
        <!-- SELECT FISCAL YEARS -->
        <!-- 
            Here, brain for how handle the prop fiscalYears without overwritten each time to change the value
         -->
        <fiscal-years-select
            :fiscalYears="form.fiscalyears"
            @updateFiscalYears="updateFiscalYears"
            @loaded="$emit('updateLoading', { loading: false })"
        />

        <!-- SELECT RATE -->
        <el-form-item
            :label="$t.__('dashboard.forms.PurInvoiceSettingForm.select_card_rate')"
            prop="rate"
        >
            <el-select v-model="form.rate" class="wp-3" multiple placeholder="">
                <el-option
                    v-for="rate in ratesList"
                    :key="rate.value"
                    :label="rate.label"
                    :value="rate.value"
                >
                </el-option>
            </el-select>
        </el-form-item>
        <!-- SUBMIT -->
        <div class="aright mt-5">
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                @click="close"
            />
            <CompassButton
                :label="$t.__('common.actions.save')"
                type="primary"
                @click="submitForm"
            />
        </div>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import FiscalYearsSelect from './FiscalYearsSelect.vue';

export default {
    mixins: [SettingsFormMixin],
    created() {
        this.$emit('updateLoading', { loading: true });
    },
    data() {
        return {
            purInvoiceRules: {
                rate: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez choisir votre taux'),
                        trigger: 'change',
                    },
                ],
            },
            ratesList: [
                {
                    value: 'marginRate',
                    label: this.$l10n.__('Taux de marge'),
                },
                {
                    value: 'markRate',
                    label: this.$l10n.__('Taux de marque '),
                },
            ],
        };
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
        updateFiscalYears(data) {
            this.form.fiscalyears = data;
        },
    },
    mounted() {
        this.$emit('set-rules', this.purInvoiceRules);
    },
    components: {
        'fiscal-years-select': FiscalYearsSelect,
    },
};
</script>
